import { Component, Input, OnInit } from '@angular/core';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { DatatableService } from '../../services/datatable.service';

@Component({
    selector: 'datatable-2-csv',
    template: `
    <button mat-raised-button (click)="downloadDatatable()">
        <mat-icon>list</mat-icon>
    </button>
  `
})
export class DatatableCsvComponent {
    @Input() dataTable: DatatableComponent;

    constructor(private _service: DatatableService) { }

    downloadDatatable(): void {
        if (this.dataTable) this._service.exportAsCSV(this.dataTable);
    }
}
